import { DataService } from 'api/DataService'

// SC-11813: avisos fixos da conta (ex.: certificado da NFS-e vencido). A API
// calcula cada um na hora; some sozinho quando a empresa resolve.
export type AccountAlert = {
  type: string
  severity: 'error' | 'warning' | 'info'
  // SC-11817: pode ser fechado; volta só no dia seguinte (ver dismissedAlerts).
  dismissible?: boolean
  title: string
  message: string
  action_label?: string
  // Caminho completo ou só a query (ex.: "?open_nps=true"), aplicada na página atual.
  action_url?: string
}

type AccountAlertsResponse = {
  error: boolean
  records?: AccountAlert[]
}

export const fetchAccountAlerts = async (): Promise<AccountAlert[]> => {
  const response = await DataService<AccountAlertsResponse>({
    type: 'GET',
    url: '/v1/account_alerts'
  })
  if (response?.error || !response?.data?.records) return []
  return response.data.records
}
